<template>
  <div class="c-convincing-deactivating-list">
    <h6 class="title is-spaced">Ajude-nos a melhorar!</h6>
    <p class="subtitle">
      Sua opinião é muito importante para nós! Conta pra gente, porque não irá
      utilizar nossa lista de presentes? É só escolher um dos motivos abaixo:
    </p>

    <div class="feedback-options">
      <b-field v-for="(option, index) in FeedbackOptions" :key="index">
        <b-radio
          v-model="optionSelected"
          size="is-medium"
          :native-value="option"
        >
          <img :src="option.image" :alt="option.label" srcset="" />{{
            option.label
          }}
        </b-radio>
      </b-field>
    </div>

    <button
      :disabled="!optionSelected"
      @click="selected"
      type="button"
      class="button is-primary"
    >
      Enviar
    </button>
  </div>
</template>

<script>
import FeedbackOptions from './FeedbackOptions'

export default {
  data() {
    return {
      FeedbackOptions,
      optionSelected: undefined,
    }
  },

  methods: {
    selected() {
      this.$emit('selected', this.optionSelected)
    },
  },
}
</script>

<style lang="scss">
.feedback-options {
  max-width: 506px;
  margin: 48px auto;
  text-align: left;

  .field {
    margin-bottom: 32px;
    &:last-child {
      margin-bottom: 0;
    }
    .b-radio.radio.is-medium {
      font-size: 16px;
      color: $neutral;
      .control-label {
        display: flex;
        line-height: 1;
        align-items: center;
        justify-content: center;

        img {
          flex: none;
          width: 18px;
          height: 18px;
          margin-right: 8px;
        }
      }
    }
  }
}
</style>
